var progressMultiStep = {
  "multiStep": {
    "backgroundColor": "#fff"
  },
  "multiStep_ol": {
    "backgroundColor": "inherit",
    "listStyle": "none",
    "padding": "0"
  },
  "multiStep__step": {
    "display": "flex",
    "flexWrap": "wrap",
    "alignContent": "flex-start",
    "backgroundColor": "inherit",
    "justifyContent": "center",
    "flex": "1 1 100%",
    "&:not(.complex) .progressTrack": {
      "width": "0"
    },
    "&:not(.current) .progressTrack": {
      "width": "0"
    }
  },
  "@media (max-width: 767px)": {
    "multiStep__step": {
      "&:last-child": {
        "flexBasis": "auto",
        "flexShrink": "0"
      }
    },
    "multiStep__step__dotBar__icon": {
      "left": "calc(50% + 1rem / 2)",
      "right": "initial",
      "transform": "translateX(-50%)"
    },
    "multiStep__step__progressBar": {
      "left": "1rem"
    }
  },
  "multiStep__stepIcon": {
    "width": "100%",
    "textAlign": "center",
    "paddingBottom": "0.3125rem",
    "color": "#97999b"
  },
  "multiStep__step__dotBar": {
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "position": "relative",
    "backgroundColor": "inherit"
  },
  "@media (min-width: 768px)": {
    "multiStep__step__dotBar": {
      "justifyContent": "center"
    },
    "multiStep__step__subDotBar": {
      "marginTop": "-0.0625rem",
      "display": "flex"
    }
  },
  "multiStep__step__dotBar__icon": {
    "position": "absolute",
    "transform": "translateX(50%)",
    "color": "#97999b",
    "display": "flex",
    "top": "-0.375rem",
    "right": "0",
    "backgroundColor": "inherit",
    "zIndex": "2"
  },
  "multiStep__step__subDotBar": {
    "transform": "translateY(-50%)",
    "display": "none",
    "justifyContent": "space-between",
    "&::before": {
      "content": "\"\"",
      "display": "block"
    },
    "&::after": {
      "content": "\"\"",
      "display": "block"
    }
  },
  "multiStep__step__progressBar": {
    "width": "calc(100% - 0.5rem)",
    "height": "2px",
    "backgroundColor": "#97999b",
    "position": "absolute",
    "left": "calc(50% + 1rem / 2)",
    "top": "50%",
    "overflowX": "visible",
    "transform": "translateY(-50%)",
    "zIndex": "1"
  },
  "multiStep__step_active__dot": {
    "backgroundColor": "#006fcf"
  },
  "multiStep__step_active__subDot": {
    "backgroundColor": "#006fcf"
  },
  "multiStep__step_active__stepIcon": {
    "color": "#006fcf"
  },
  "multiStep__step_active__dotLabel": {
    "color": "#006fcf"
  },
  "multiStep__step_active__progressBar__progressTrack": {
    "width": "100%"
  },
  "multiStep__step_active__dotBar__icon": {
    "color": "#006fcf"
  },
  "multiStep__step_complex__progressBar": {
    "width": "calc(100% - 1rem)"
  },
  "multiStep__step_current__dotBar": {
    "marginTop": "-0.125rem"
  },
  "multiStep__step_current____dot": {
    "marginTop": "-0.125rem"
  },
  "multiStep__step_current__dot": {
    "height": "1.3125rem",
    "width": "1.3125rem",
    "border": "0.125rem solid #00175a",
    "boxShadow": "inset 0 0 0 0.125rem #fff",
    "backgroundColor": "#00175a"
  },
  "multiStep__step_current__subDot": {
    "backgroundColor": "#00175a"
  },
  "multiStep__step_current__subDot_currentSub____subDot": {
    "backgroundColor": "#97999b"
  },
  "multiStep__step_current__stepIcon": {
    "color": "#00175a"
  },
  "multiStep__step_current__dotLabel": {
    "marginTop": "-0.125rem",
    "color": "#00175a"
  },
  "multiStep__step_current__progressBar": {
    "top": "calc(50% - 1px)"
  },
  "multiStep__step_current__progressBar__progressTrack": {
    "backgroundColor": "#00175a"
  },
  "multiStep__step__dot": {
    "height": "1rem",
    "width": "1rem",
    "backgroundColor": "#97999b",
    "borderRadius": "50%",
    "zIndex": "2",
    "alignSelf": "center"
  },
  "multiStep__step__dotLabel": {
    "width": "100%",
    "textAlign": "center",
    "padding": "0.5rem 0.625rem 0",
    "color": "#53565a"
  },
  "multiStep__step__subDot": {
    "height": "0.625rem",
    "width": "0.625rem",
    "backgroundColor": "#97999b",
    "borderRadius": "50%",
    "zIndex": "2",
    "alignSelf": "center"
  }
};

export default progressMultiStep;
